import {
    GETUSERACTIVITYLOG_SUCCESS,
    GETUSERACTIVITYLOG_FAILED,
    RESET_GETUSERACTIVITYLOG,
    LOADING_GETUSERACTIVITYLOG,
    NETWORK_GETUSERACTIVITYLOG,
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetGetUserActivityLog = () => {
    return { type: RESET_GETUSERACTIVITYLOG };
};

const getUpdateUserActivityLog =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETUSERACTIVITYLOG });
        await partnerServices
            .post("getUserActivityLog", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {

                switch (res.data.status) {

                    case "SUCCESS":

                        dispatch(getUserActivityLogSuccess(res.data));
                        break;
                    default:
                        dispatch(getUserActivityLogFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_GETUSERACTIVITYLOG,
                    payload: err,
                });
            });

        function getUserActivityLogSuccess(data) {

            return {
                type: GETUSERACTIVITYLOG_SUCCESS,
                payload: data,
            };
        }

        function getUserActivityLogFailed(data) {
            return {
                type: GETUSERACTIVITYLOG_FAILED,
                payload: data,
            };
        }
    };
export { resetGetUserActivityLog, getUpdateUserActivityLog };
